import * as React from 'react';
import { Route } from '@reverbdotcom/commons/dist/route_settings';
import { MARKETPLACE_PATH } from '../components/shared/constants';

const MarketplaceRoute = [
  <Route
    key={MARKETPLACE_PATH}
    path={MARKETPLACE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/marketplace/marketplace_page_wrapper').default);
        },
        'marketplace',
      );
    }}
  />,
];

export default MarketplaceRoute;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/routes/marketplace.tsx